import { createStore, combineReducers, applyMiddleware } from 'redux';
import { createLogger } from 'redux-logger';
import thunkMiddleware from 'redux-thunk';

import { vkuiReducer } from './vkuiReducer';
import { userReducer } from './userReducer';
import { appReducer } from './appReducer';
import { routerReducer } from './routerReducer';
import { donutsReducer } from './donutsReducer';
import { randomizerReducer } from './randomizerReducer';
import { groupReducer } from './groupReducer';
import { exporterReducer } from './exporterReducer';

let reducers = combineReducers({
    app: appReducer,
    router: routerReducer,
    //vkui: vkuiReducer,
    user: userReducer,
    //donuts: donutsReducer,
    //randomizer: randomizerReducer,
    //group: groupReducer,
    //exporter: exporterReducer,
});


// ******* MIDDLEWARES *******

let middlewares = [
    thunkMiddleware
];

// Logger in Dev Mode Only
if (process.env.NODE_ENV === "development") {

    const logger = createLogger({
        collapsed: true,
        predicate: (getState, action) => {
            let skipActions = ['ACTION_TO_IGNORE'];
            if ( skipActions.indexOf(action.type) >= 0 ) {
                return false;
            }
            return true;
        },
    });

    middlewares.push(logger);

}


export const store = createStore(
    reducers,
    applyMiddleware(
        ...middlewares
    )
);
